import i18n from '@/i18n/i18n'
import { OrderItemService } from '@/services/admin/OrderItemService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = [
  'order.status',
  'order.retailer.address.city.region_id',
  'order.retailer.address.city_id',
  'order.retailer.address.county_id',
  'order.retailer.id',
  'product_id',
  'brand_id',
  'created_between',
  'farmer_payment_date_between'
]
export const allowedIncludes = 'product,unit,productUnit,brand,order.retailer.address'
export const allowedSorts = '-created_at'

export const state = {
  items: [],
  item: {},
  meta: null
}

export const mutations = {
  SET_ORDER_ITEMS(state, items) {
    state.items = items.data
    state.meta = items.meta
  },
  SET_ORDER_ITEM(state, item) {
    state.item = item
  }
}

export const actions = {
  getOrderItems({ commit }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts)

    return new Promise(resolve => {
      let orderItemService = new OrderItemService(newQuery)
      orderItemService.getOrderItems().then(response => {
        commit('SET_ORDER_ITEMS', response)
        resolve(response.data)
      })
    })
  },
  getOrderItem({ commit }, id) {
    return new Promise(resolve => {
      let orderItemService = new OrderItemService()
      orderItemService.getOrderItem(id).then(response => {
        commit('SET_ORDER_ITEM', response.data)
        resolve(response.data)
      })
    })
  },
  export({ dispatch }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts)

    return new Promise(resolve => {
      let orderItemService = new OrderItemService(newQuery)
      orderItemService.export().then(response => {
        const notification = {
          type: 'info',
          message: t('store.admin.order_item.export_success')
        }
        dispatch('notification/add', notification, {
          root: true
        })
        resolve(response)
      })
    })
  },
  update({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      let orderItemService = new OrderItemService()
      orderItemService
        .updateOrderItem(data.id, {
          product_unit_id: data.product_unit_id,
          quantity: data.quantity,
          unit_price: data.price
        })
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.order_item.order_item_updated')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: `${t('store.admin.order_item.order_item_update_failed')} ${errorMessage(err)}`
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
